module.exports = __webpack_public_path__ + "img/sty_1.a14db7bc.png";